import { render, staticRenderFns } from "./BlobButton.vue?vue&type=template&id=df9b171e&"
import script from "./BlobButton.vue?vue&type=script&lang=js&"
export * from "./BlobButton.vue?vue&type=script&lang=js&"
import style0 from "./BlobButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports